import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
import { HeroSection } from "./components/sections/HeroSection";
import { IntroSection } from "./components/sections/IntroSection";
import { BeforeAfterSection } from "./components/sections/BeforeAfterSection";
import { PainPointsSection } from "./components/sections/PainPointsSection";
import { VolumesSection } from "./components/sections/VolumesSection";
import { ToolkitSection } from "./components/sections/ToolkitSection";
import { BonusesSection } from "./components/sections/BonusesSection";
import { OfferSection } from "./components/sections/OfferSection";
import { GuaranteeSection } from "./components/sections/GuaranteeSection";
import { ExpectationsSection } from "./components/sections/ExpectationsSection";
import { AuthorSection } from "./components/sections/AuthorSection";
import { TestimonialsSection } from "./components/sections/TestimonialsSection";
import { FAQSection } from "./components/sections/FAQSection";
import { FinalCTASection } from "./components/sections/FinalCTASection";
import { SiteFooter } from "./components/sections/SiteFooter";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-ink font-sans text-white antialiased" data-id="element-0" data-mp="5yh2n2cyzbp">
      <MetaPixel data-id="element-1" data-mp="2zld1d7i6tbah" />
      <HeroSection data-id="element-2" data-mp="2zlv6ktmtuzuj" />
      <main data-id="element-3" data-mp="2zmeowbge3q93">
        <IntroSection data-id="element-4" data-mp="2zmo5x9jgin2n" />
        <BeforeAfterSection data-id="element-5" data-mp="2zng0qi58cgrv" />
        <PainPointsSection data-id="element-6" data-mp="33m5a7zn5de68" />
        <VolumesSection data-id="element-7" data-mp="33ngee0ki8nxv" />
        <ToolkitSection data-id="element-8" data-mp="33ori60dy9voz" />
        <BonusesSection data-id="element-9" data-mp="38lrpsfqg76i7" />
        <OfferSection data-id="element-10" data-mp="38li7zffk45nl" />
        <GuaranteeSection data-id="element-11" data-mp="38l00tnrcw70w" />
        <ExpectationsSection data-id="element-12" data-mp="38nulngea7tuu" />
        <AuthorSection data-id="element-13" data-mp="3dle1ulujigpf" />
        <TestimonialsSection data-id="element-14" data-mp="3dlw4q1bpjt6b" />
        <FAQSection data-id="element-15" data-mp="3dm5vhr4ku4d2" />
        <FinalCTASection data-id="element-16" data-mp="nvj4pj9gikrb" />
      </main>
      <SiteFooter data-id="element-17" data-mp="nuhged3fk1rn" />
      <FloatingCTA data-id="element-18" data-mp="nv0ybtt2yq5o" />
      <PurchasePopup data-id="element-19" data-mp="nxn4bp0boxls" />
    </div>;
}